import React, { useState } from "react";
import { Box, Typography, Avatar } from "@mui/material";
import {
  isFinanceRole,
  isMemberRole,
  getRole,
  convertUserImage,
  displayUserName,
  displayUserNickname,
} from "../../../util/utils"
import { adjustUserInfo } from "../../../util/MultiMenu";
import MultiMenu from "../../MultiMenu";

interface User {
  id: number;
  [key: string]: any; // Add more fields as needed
}

interface UserCardListProps {
  targetUser: User;
  role: string;
  myRole: string;
  groupInfo: any;
}

const UserCardList: React.FC<UserCardListProps> = ({
  targetUser,
  role,
  myRole,
  groupInfo,
}) => {
  const [showName, setShowName] = useState<boolean>(false);
  const pIIRequired: boolean = groupInfo.personal_information_needed
  const userAvatar: string = convertUserImage(targetUser?.image)
  const userNickname: string = targetUser?.nickname

  const handleShowName = () => {
    if (isMemberRole(role)) {
      setShowName(pIIRequired ? !showName : false);
    } else {
      setShowName(!showName);
    }
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "7px",
          marginLeft: "18px",
          borderBottom: "2px solid #E5E5E5",
        }}
      >
        {/* Left Section: User Icon, Name, Role */}
        <Box
          sx={{ display: "flex", alignItems: "center" }}
        >
          <Avatar src={userAvatar} sx={{ width: 30, height: 30, mr: 2 }} alt={userNickname?.charAt(0)?.toUpperCase()} />
        </Box>
        <Box
        sx={{
          display: "flex",
          alignItems: "end",
          width: "100%",
          justifyContent: "space-between",
        }}>
          <Box
            onClick={() => {
              if (isMemberRole(myRole) || isFinanceRole(myRole)) return;
              handleShowName()
            }}
          >
            <Typography>{displayUserNickname(userNickname)}</Typography>
          </Box>

          <Box
            sx={{ display: "flex",  }}
          >
            {role && (
              <Typography variant="body2" color="text.secondary">
                &nbsp; {!isMemberRole(role) && getRole(role)}
              </Typography>
            )}
          </Box>
        </Box>
        <MultiMenu
          targetUser={adjustUserInfo(targetUser, groupInfo)}
          groupInfo={groupInfo}
          menuType={"group_user"}
        />
      </Box>

      {showName &&
        <Box
          sx={{
            width: "100%",
            padding: "40px 20px",
            textAlign: "center",
            border: "solid 2px #E5E5E5"
          }}
        >
          <Typography>
            {targetUser?.name && "氏名："}
            {displayUserName(targetUser?.name)}
          </Typography>
        </Box>
      }
    </Box>
  );
};

export default UserCardList;
